<template>
    <div>

        <PageHeader>
            {{ $t('reportsCategories') }}
            <template #side>
                <div class="d-flex gap-3">
                    <ButtonResetFilters @click="resetFilters()" />
                    <TimeRangeCalendar ref="TimeRangeCalendar" v-model="timeRange" compare-year />
                </div>
            </template>
        </PageHeader>

        <ImpressionsReport />

        <SalesReport />

        <CategoryReport />

        <CategoryRanking />

        <CategoryHeatmap />

    </div>
</template>



<script>
    import ButtonResetFilters from '@/components/common/ButtonResetFilters.vue';
    import TimeRangeCalendar from '@/components/common/TimeRangeCalendar.vue';
    import ImpressionsReport from './parts/ImpressionsReport.vue';
    import SalesReport from './parts/SalesReport.vue';
    import CategoryReport from './parts/CategoryReport.vue';
    import CategoryRanking from './parts/CategoryRanking.vue';
    import CategoryHeatmap from './parts/CategoryHeatmap.vue';

    export default {
        name: 'ReportsCategories',
        components: {
            ButtonResetFilters,
            TimeRangeCalendar,
            ImpressionsReport,
            SalesReport,
            CategoryReport,
            CategoryRanking,
            CategoryHeatmap,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                timeRange: null,
            };
        },
        methods: {
            resetFilters() {
                this.$emit('resetFilters');
                this.$refs.TimeRangeCalendar.resetDate();
            },
        },
    };
</script>
